import { render } from "./MensagensLista.vue?vue&type=template&id=2b75db06"
import script from "./MensagensLista.vue?vue&type=script&lang=js"
export * from "./MensagensLista.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__